import {deleteJson, getJson, postJson, putJson} from '@/util/ajaxUtils';

export function getJob(jobId) {
    return getJson(`/jobs/${jobId}`);
}

export function addJob(data) {
    return postJson(`/jobs`, {data});
}

export function updateJob(jobId,data) {
    data.jobId = jobId;
    return putJson(`/jobs`, {data});
}

export function changeJobStatus(jobId, status) {
    const data = {
        jobId,
        status
    }
    return putJson(`/jobs/changeStatus`, {data});
}

/**
 * 运行一次
 *
 * @param jobId
 * @param jobGroup
 */
export function runJob(jobId,jobGroup) {
    const data = {
        jobId,
        jobGroup
    }
    return putJson(`/jobs/run`, {data});
}

export function deleteJob(jobIds) {
    return deleteJson(`/jobs/${jobIds}`);
}


export function getJobLog(jobLogId) {
    return getJson(`/jobLogs/${jobLogId}`);
}


export function getTaskResult(taskHistoryId) {
    return getJson(`/taskHistories/${taskHistoryId}`);
}

export function getJobNames(){
    return getJson(`/jobs/getJobNames`);
}
